﻿import {Core} from "../../Base/Core";
import {UpgradeType} from "../../enums";
import {UpgradeItem} from "../UpgradeItem";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";

export class UIUpgrades extends UICommonPopup {
    Awake() {
        super.Awake({
            masked: true,
            title: Core.Localizator.Get("upgrades"),
            closeButton: true,
        });

        this.items = []; // UpgradeItem[] items;
        this.attentionInitialized = false;
        this.attentionDic = new Map(); // Dictionary<UpgradeType, int>
        this.hasAttentions = false;
    }

    Init() {
        super.Init();
        this.onChangedPlayer = this.onChangedPlayer.bind(this);

        let list = [UpgradeType.BubbleTime, UpgradeType.MoneyBox, UpgradeType.BubbleCreature];

        for (let upgradeType of list) {
            let item = this.content.addChild(new UpgradeItem());
            item.Init(upgradeType);
            this.items.push(item);
        }
        Core.Player.on("Changed", this.onChangedPlayer);
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.7;
        let w = Math.min(viewport.width * 0.85, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let headerRect = new PIXI.Rectangle(this.header.x, this.header.y, this.header.width, this.header.height);
        let padding = w * 0.02;
        let activeItemsCount = 0;
        let itemRect = new PIXI.Rectangle(padding, headerRect.height + padding, popupRect.width - padding * 2, popupRect.height * 0.166);

        for (let item of this.items) {
            item.fitLayout(itemRect);
            itemRect.y += itemRect.height + padding;
            if (item.Active) activeItemsCount++;
        }
    }

    onChangedPlayer() {}

    Show() {
        for (let item of this.items) {
            item.UpdateUI();
        }
        super.Show();
    }

    Hide() {
        if (this.Active) {
            Core.Ads.TriggerInterstitial();
        }
        super.Hide();
    }
}
